import { render, staticRenderFns } from "./settings-company-plugins.vue?vue&type=template&id=2329c2a5&scoped=true&"
import script from "./settings-company-plugins.ts?vue&type=script&lang=ts&"
export * from "./settings-company-plugins.ts?vue&type=script&lang=ts&"
import style0 from "./settings-company-plugins.vue?vue&type=style&index=0&id=2329c2a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2329c2a5",
  null
  
)

export default component.exports